<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>物业管理</el-breadcrumb-item>
      <el-breadcrumb-item>水费管理</el-breadcrumb-item>
    </el-breadcrumb>

    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.roomName" placeholder="输入房间名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input size="small" v-model="formInline.meterName" placeholder="输入水表名称"></el-input>
      </el-form-item>
     <el-form-item v-if="user.username == 'admin'" label="选择部门">
         <el-select v-model="formInline.depId" placeholder="请选择部门"  size="small">
            <el-option
              v-for="item in deptList"
              :key="item.id"
              :label="item.departmentName"
              :value="item.id">
            </el-option>
          </el-select>
      </el-form-item>

      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-circle-plus-outline" @click="handelAdd">添加</el-button>
      </el-form-item>
      <el-form-item>
      	<el-upload action="" multiple :http-request="importData" :show-file-list="false" >
      		<el-button type="success" size="small" icon="el-icon-upload2"  :loading="loadLoadin" >导入</el-button>
      	</el-upload>

      </el-form-item>

    </el-form>

   <el-table  :header-cell-style="this.$store.state.headerCss" size="small" :data="dataList" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中"
    style="width: 100%;"  stripe :max-height="tableHeight">
      <el-table-column align="center" type="index" width="60">
      </el-table-column>
      <el-table-column  prop="meterName" label="水表名称" show-overflow-tooltip>
      </el-table-column>
      <el-table-column  prop="roomName" label="房间名称" show-overflow-tooltip>
      </el-table-column>

      <el-table-column  prop="startDate" label="开始时间" >
      </el-table-column>
      <el-table-column  prop="endDate" label="结束时间" >
      </el-table-column>

      <el-table-column  prop="totalValue" label="用量" >
      </el-table-column>

      <el-table-column  prop="startValue" label="起码" >
      </el-table-column>
      <el-table-column  prop="endValue" label="止码" >

      </el-table-column>
      <el-table-column  prop="waterMonth" label="统计月份" >
      </el-table-column>
     <el-table-column align="center" label="操作">
        <template slot-scope="scope">

          <prems-button size="mini" perms="wm:detail" @click="handleEdit(scope.row)" label="编辑" />
          <prems-button type="danger" size="mini" perms="wm:delete" @click="deleteInfo(scope.row)" label="删除" />
          <!-- <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button> -->
          <!-- <el-button size="mini" type="danger"    @click="deleteInfo(scope.row)">删除</el-button> -->

        </template>
      </el-table-column>
    </el-table>

    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="formInline" @callFather="callFather" v-if="showPage"></Pagination>



    <el-dialog :title="title" :visible.sync="editFormVisible" width="35%" @click="editFormVisible = false"  :close-on-click-modal="false">
    	<el-form label-width="100px" :model="editForm" :rules="rules" ref="editForm">

    		<el-form-item label="水表名称" prop="username">
    			<el-input size="small" v-model="editForm.meterName" auto-complete="off" placeholder="请输入水表名称"></el-input>
    		</el-form-item>
    		<el-form-item label="用量" prop="phoneNumber">
    			<el-input size="small"  type="number" v-model="editForm.totalValue" auto-complete="off" placeholder="请输入用量"></el-input>
    		</el-form-item>
        <el-form-item label="开始时间">
        	<el-date-picker style="width:100%" size="small" v-model="editForm.startDate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间" >
        	<el-date-picker  style="width:100%" size="small" v-model="editForm.endDate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
        <el-form-item label="起码" prop="phoneNumber">
        	<el-input size="small" type="number" v-model="editForm.startValue" auto-complete="off" placeholder="请输入起码"></el-input>
        </el-form-item>
        <el-form-item label="止码" prop="phoneNumber">
        	<el-input size="small" type="number" v-model="editForm.endValue" auto-complete="off" placeholder="请输入止码"></el-input>
        </el-form-item>
        <el-form-item label="统计月份" prop="phoneNumber">

          <el-date-picker style="width:100%" size="small" v-model="editForm.waterMonth" type="month" placeholder="选择日期" value-format="yyyy-MM"></el-date-picker>

        </el-form-item>

        <el-form-item label="选择房间">
          <el-select size="small" v-model="editForm.roomId" filterable style="width:100%">
            <el-option v-for="item in roomList"  :value="item.id" :label="item.roomName"></el-option>
          </el-select>
        </el-form-item>



    	</el-form>
    	<div slot="footer" class="dialog-footer">
    		<el-button size="small" @click="editFormVisible = false">取消</el-button>
    		<el-button size="small" type="primary" :loading="setLoading" class="title" @click="submitForm('editForm')">保存</el-button>
    	</div>
    </el-dialog>



  </div>
</template>

<script>
  import PremsButton from "@/views/permission/PreButtom";
  import Pagination from '../../components/Pagination'
  import { getDepartmentTerminalInfoLis,findMeterInfoList } from '../../api/energyMG'
  import {
   addWaterMeter,
   findWaterMeterList,
   findAllRoomList,
   modifyWaterMeter,
   uploadWaterMeter,
   removeWaterMeter,
   generateWaterAndPropertyMonthlyBill
  } from '../../api/payMG.js'

  export default {
    data() {


      return {
        formInline: {
          depId:"",
          roomName:"",
          meterName:"",
          pageSize:10,
          currentPage:1,
          total:0,

        },
        user:{},
        deptList:[],
        roomInline: {
          depId:'',
          pageSize:99999,
          currentPage:1,
          total:0,
          meterInfoName:"",
          username:"",
          phoneNumber:"",
          roomName:"",
        },
        downloadLoadin:false,
        saveLoad:false,

        totalFee:"",
        users:[],
        editForm:{
          meterName:"",
          totalValue:"",
          startDate:"",
          endDate:"",
          startValue:"",
          endValue:"",
          waterMonth:"",
          roomId:"",
        },

        roomList:[],


        pageparm:{

        },
        depId:"",
        rtitle:"",
        rechargeFormVisible:false,
        setLoading:false,
        tableHeight:0,
        title:"",
        loading:false,
        meterPointName:"",
        editFormVisible:false,
        dataList:[],
        deptList:[],
        user:{},
        showPage:true,

        dForm:{
          roomName:"",
          userName:'',
          blance:"",

        },
        money:{
          water:'',
          wuYe:"",
        },
        loadLoadin:false,

        rules: {
        	// username: [{
        	// 	required: true,
        	// 	message: '请输入联系人',
        	// 	trigger: 'blur'
        	// }],

        	// roomNum:[{validator:validatePass,trigger:'change' }]

        },
      }
    },
    mounted(){
      this.$nextTick(() => {
      	this.tableHeight = window.innerHeight - 300
      })
    },
    created(){
      this.getRoomList();
      this.getData()

      this.user = JSON.parse(sessionStorage.getItem('userdata'))
      this.getJzData()





    },
    components: {
      Pagination,
      PremsButton
    },
    methods:{
      getJzData:function(){
      	return new Promise((resolve,reject) => {
      		getDepartmentTerminalInfoLis().then(res => {
      			this.treeLoad = false
      			if(res.status == 1){
      				let arr = []
      				this.deptList = res.data.menuDepList
              res.data.terIds.forEach( item => {
              	arr.push({ id: item})
              })
              resolve(this.deptList[0])

      			}
      			else{
      				this.$message.error(res.msg)
      			}
      		})
      	})

      },

      getData(){
        findWaterMeterList(this.formInline).then(res => {
          if(res.status == 1){
            this.dataList = res.data.data
            this.formInline.total = res.data.totalCount
          }else{
            this.$message.error(res.msg)
          }
        })
      },

      importData(val) {
      	this.loadLoadin = true

      	let  formData = new FormData();
      	formData.append('file', val.file);

      	uploadWaterMeter(formData).then(res => {
      		this.loadLoadin = false
      		if(res.status == 1){
      			this.$message.success(res.msg)
      			this.getData();
      		}else{
      			this.$message.error(res.msg)
      		}
      	})
      },



      getRoomList(){
        findAllRoomList(this.roomInline).then(res => {

          if(res.status == 1){
            this.roomList = res.data.data

          }else{
            this.$message.error(res.msg)
          }
        })
      },
      handelAdd(){
        this.editFormVisible = true
        this.title = '添加'

        this.editForm.meterName = ""
        this.editForm.totalValue = ""
        this.editForm.startDate = ""
        this.editForm.endDate = ""
        this.editForm.startValue = ""
        this.editForm.endValue = ""
        this.editForm.roomId = ''
         this.editForm.waterMonth = ""

      },

      handleEdit(row){
        this.title = '编辑'

        this.editFormVisible = true
        this.editForm.id = row.id
       this.editForm.meterName = row.meterName
       this.editForm.totalValue = row.totalValue
       this.editForm.startDate = row.startDate
       this.editForm.endDate = row.endDate
       this.editForm.startValue = row.startValue
       this.editForm.endValue = row.endValue
       this.editForm.roomId = row.roomId
       this.editForm.waterMonth = row.waterMonth

      },
      search(){

        this.formInline.currentPage = 1
        this.showPage = false
        this.getData()
        this.$nextTick(()=>{
        	this.showPage = true
        })
      },
      callFather(parm){
        this.formInline.currentPage = parm.currentPage
        this.formInline.pageSize = parm.pageSize
        this.getData()

      },

      deleteInfo(row){
        this.$confirm('确定要删除吗?', '信息', {
        		confirmButtonText: '确定',
        		cancelButtonText: '取消',
        		type: 'warning'
        	})
        	.then(() => {
        		// 删除
        		removeWaterMeter({
        				id: row.id
        			})
        			.then(res => {
        				if (res.status == 1) {
        					this.$message({
        						type: 'success',
        						message: '已删除!'
        					})
        					this.getData()
        				} else {
        					this.$message({
        						type: 'info',
        						message: res.msg
        					})
        				}
        			})
        			.catch(err => {
        				this.loading = false
        				this.$message.error('删除失败，请稍后再试！')
        			})
        	})
        	.catch(() => {
        		this.$message({
        			type: 'info',
        			message: '已取消删除！'
        		})
        	})
      },




      submitForm(){

        if(this.title == '添加'){
          this.add()
        }else{
          this.update()
        }

      },

      add(){
        addWaterMeter(this.editForm).then(res => {
          if(res.status == 1){
            this.editFormVisible = false
            this.$message.success("操作成功")
            this.getData();
          }else {
            this.$message.error(res.msg)
          }
        })
      },
      update(){
        modifyWaterMeter(this.editForm).then(res => {
          if(res.status == 1){
            this.editFormVisible = false
            this.$message.success("操作成功")
            this.getData();
          }else {
            this.$message.error(res.msg)
          }
        })
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/property/waterManage.vue